import * as types from '../constants';
import LocalStorageUtility from '../common/localStorageUtility/localStorageUtility';

const initialState = {
  showTooltip: false,
  showed: false,
};

export default function tooltipReducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_TOOLTIP:
      if (!state.showed && LocalStorageUtility.getSessionCounter() < 4) {
        return {
          showTooltip: true,
          showed: true,
        };
      } else {
        return state;
      }
    case types.HIDE_TOOLTIP:
      return {
        ...state,
        showTooltip: false,
      };
    default:
      return state;
  }
}
